import { observable, action } from "mobx";
import makeApi, { URLS } from "Utils/apiURL";
import { toasterState } from "Components/common/toaster";
import { reconnectSequenceLoadingPopupState } from "./ReconnectSequenceLoadingPopupState";
import { confirmationPopupState } from "Components/common/confirmationPopup";
class ReconnectSequencePopupState {
  defaultPopupValue = {
    email: "",
    userName: "",
    type: "gmail_oath",
    inboxId: "",
    sequences: [],
    connectedInbox: {}
  };

  @observable showPopup = false;
  @observable isReconnecting = false;
  @observable popupValues = { ...this.defaultPopupValue };
  @observable isFetching = false;

  @action
  setShowPopup = (val = false) => {
    this.showPopup = val;
    if (val) {
      document.getElementsByTagName("body")[0].classList.add("scrollHidden");
    } else {
      this.popupValues = { ...this.defaultPopupValue };
      document.getElementsByTagName("body")[0].classList.remove("scrollHidden");
    }
  };

  @action
  setPopupValues = (val = {}) => {
    this.popupValues = { ...val };
  };

  @action
  setSequences = (val = []) => {
    this.popupValues.sequences = [...val];
  };

  @action
  setEmail = (val = "") => {
    this.popupValues.email = val;
  };

  @action
  setUserName = (val = "") => {
    this.popupValues.userName = val;
  };

  @action
  setType = (val = "") => {
    this.popupValues.type = val;
  };

  @action
  setInboxId = (val = "") => {
    this.popupValues.inboxId = val;
  };

  @action
  setConnectedInbox = (val = {}) => {
    this.popupValues.connectedInbox = { ...val };
  };


  @action
  getAllCampaignSequences = async (inboxId = "", connectedInbox = {}) => {
    try {
      this.isFetching = true;

      const config = {
        url: URLS.getCampaignSequences + "/" + inboxId,
        method: "GET"
      }
      let res = await makeApi(config);

      if (res?.data?.length > 0) {
        this.setInboxId(inboxId);
        this.setConnectedInbox(connectedInbox)
        this.setSequences(res?.data)
        this.setEmail(connectedInbox?.email);
        this.setUserName(connectedInbox?.userName);
        this.setType(connectedInbox?.type);
        this.setShowPopup(true);
      } else {
        this.resetPopupData()
      }
    } catch (err) {
      console.error("Error while fetching the campaign sequences for the inbox", err)
    } finally {
      this.isFetching = false;
    }
  }

  @action
  reconnectSequences = async (sequenceIds = []) => {
    try {
      this.isReconnecting = true;
      const config = {
        url: URLS.reconnectResumeSeq,
        method: "POST",
        data: {
          inboxId: this.popupValues.inboxId || "",
          emailAddress: this.popupValues.email || "",
          sequenceIds: sequenceIds
        }
      }
      const res = await makeApi(config);
      const { background = false } = res?.data || {};

      this.setShowPopup(false);
      this.isReconnecting = false;

      if (background) {
        confirmationPopupState.setPopupValues({
          content: `Reconnecting the inbox to selected sequences…<br>This may take a few minutes.`,
          actionBtnText: "Close",
          needCancelBtn: false,
          callback: () => {
            confirmationPopupState.setShowPopup(false);
          }
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        reconnectSequenceLoadingPopupState.setData(res?.data);
        reconnectSequenceLoadingPopupState.setShowPopup(true);
      }
    } catch (err) {
      console.error("Error while reconnecting the sequences", err)
      this.isReconnecting = false;
      toasterState.setToastMsg("Error while reconnecting the sequences", "fail");
    } finally {
      this.resetPopupData()
    }
  }

  @action
  resetPopupData = () => {
    this.setPopupValues({ ...this.defaultPopupValue })
  }
}

const reconnectSequencePopupState = new ReconnectSequencePopupState();

export { reconnectSequencePopupState };
export default reconnectSequencePopupState;
